<div class="navigation-left">
  <a class="arrow arrow-left" (click)="goBack()" translate="add-account-fb/loc/back"></a>
</div>

<mat-card>
  <h1 translate="add-account-fb/loc/title"></h1>
  <p [innerHTML]="'add-account-fb/loc/intro' | translate"></p>
  <form [formGroup]="selectAccountForm">
    <app-select
      appearance="outline"
      [items]="facebookSitesChoices"
      [labelKey]="'account'"
      [control]="selectAccountForm.get('site')"></app-select>
  </form>

  <div class="bar">
    <div>
      {{ dataSource.filteredData.length }}
      <span [translate]="dataSource.filteredData.length > 1 ? 'results' : 'result'"></span>
    </div>

    <span class="separator"></span>

    <div>
      <button
        mat-raised-button
        type="button"
        color="primary"
        (click)="showSiteGroupDialog()"
        [disabled]="!selection?.selected.length">
        <span
          [translate]="
            selection?.selected.length > 1
              ? 'add-account-fb/loc/button/connect/several'
              : 'add-account-fb/loc/button/connect'
          "
          [translateParams]="{ nb: selection?.selected.length || 0 }">
        </span>
      </button>
    </div>

    <div>
      <app-select
        appearance="outline"
        [control]="filtersGroup.get('statuses')"
        [items]="statusesChoices"
        [multiple]="true"
        labelKey="add-account-fb/loc/status/label">
      </app-select>
    </div>

    <div>
      <app-select
        appearance="outline"
        [control]="filtersGroup.get('operator')"
        [items]="operatorsChoices"
        labelKey="add-account-fb/loc/filters/operators/label">
      </app-select>
    </div>

    <div>
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="add-account-fb/loc/filters/operators/search"></mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input autocomplete="off" [formControl]="$any(filtersGroup.get('search'))" matInput />
        <mat-icon role="button" *ngIf="filtersGroup.value.search" (click)="clearSearch()" matSuffix>close</mat-icon>
      </mat-form-field>
    </div>

    <a *ngIf="hasFilters()" (click)="clearFilters()" class="clear-filters">
      <mat-icon>backspace</mat-icon>
      {{ 'search-bar/uncheck-filters' | translate }}
    </a>
  </div>

  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection?.hasValue() && isAllSelected"
          [disabled]="!filteredDataNotConnectedLength"
          [indeterminate]="selection?.hasValue() && !isAllSelected"
          [matTooltip]="masterCheckboxLabel">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let location">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? toggleRow(location) : null"
          [checked]="selection.isSelected(location)"
          [matTooltip]="getCheckboxLabel(location)"
          [disabled]="
            location.connectionStatus === 'connected' ||
            (selection.selected.length >= MAX_CONNECTIONS_ALLOWED && !selection.isSelected(location))
          ">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="add-account-fb/loc/status/label"></span>
      </th>

      <td mat-cell *matCellDef="let location">
        <mat-chip-list>
          <mat-chip [ngClass]="location.chipColor">
            <span class="alc-ellipsis" [matTooltip]="location.connectionStatusText" appMatTooltipShowIfTruncated>{{
              location.connectionStatusText
            }}</span>
            <span *ngIf="location.error">
              &nbsp;<mat-icon class="error-icon" (click)="showStatusError(location.error)">help_outline</mat-icon>
            </span>
          </mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="add-account-fb/loc/column/name"></span>
      </th>
      <td mat-cell *matCellDef="let location">{{ location.name }}</td>
    </ng-container>

    <ng-container matColumnDef="link">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="add-account-fb/loc/column/link"></span>
      </th>
      <td mat-cell *matCellDef="let location">
        <a [href]="location.link" class="flex-align-center" target="_blank"
          >{{ location.link }}&nbsp;<mat-icon>open_in_new</mat-icon></a
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="add-account-fb/loc/column/id"></span>
      </th>
      <td mat-cell *matCellDef="let location">{{ location.id }}</td></ng-container
    >

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-card>

<app-progression-dialog
  *ngIf="showProgressionDialog"
  [data]="progressionDialogData"
  (closeDialog)="closeProgressionDialog()"></app-progression-dialog>
